// @ts-ignore
import React, { FC, useId } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import { CircularLoader } from '../../shared';

interface FolderManagerSidebarProps {
  data?: any;
  isLoading: boolean;
  selectedItem: any;
  onSelect: (data: any) => void;
}

const StyledMenuList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

const StyledMenuItem = styled.li`
  cursor: pointer;
  height: 20px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 20px 10px;

  .icon {
    svg {
      position: relative;
      top: 1px;
      font-size: 1.4rem;
    }
  }

  &:hover {
    background-color: lightgrey;
  }

  &.selected {
    background-color: lightblue;
  }
`;

const iconMap: any = {
  BackupTableIcon: <BackupTableIcon />,
  WorkspacesOutlinedIcon: <WorkspacesOutlinedIcon />,
  PermMediaOutlinedIcon: <PermMediaOutlinedIcon />,
  DeleteOutlineOutlinedIcon: <DeleteOutlineOutlinedIcon />,
};
const getIcon = (iconName: string) => iconMap?.[iconName] || null;

export const FolderManagerSidebar: FC<FolderManagerSidebarProps> = ({ data, isLoading, onSelect, selectedItem }) => {
  const uniqueId = useId();

  const handleItemClick = (item: any) => {
    onSelect(item);
  };

  return (
    <Card>
      <CardContent>
        {isLoading ? (
          <CircularLoader containerMinHeight={'190px'} centered />
        ) : (
          <StyledMenuList>
            {(data || []).map((item: any) => (
              <StyledMenuItem
                key={`${uniqueId}-${item?.slug || item?.displayName}`}
                onClick={() => handleItemClick(item)}
                className={classNames({ selected: selectedItem?.slug === item?.slug })}
              >
                {item?.icon && <span className="icon">{getIcon(item?.icon)}</span>}
                {item.displayName}
              </StyledMenuItem>
            ))}
          </StyledMenuList>
        )}
      </CardContent>
    </Card>
  );
};
